import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ModalComponent, PopUpService, QuestionBase, TextareaQuestion } from 'core/index';
import { Cache } from 'core/models/cache';
import { MarsDebatesService } from '../mars-debates.service';
import { Debate } from '../debate';
import { MarsDebateOpinionsListService } from './mars-debate-opinions-list.service';

@Component({
  selector: 'lms-mars-debate',
  templateUrl: './mars-debate.component.html',
  styleUrls: ['./mars-debate.component.scss'],
  providers: [MarsDebateOpinionsListService]
})
export class MarsDebateComponent implements OnInit {
  @Input() debate: Debate;
  @Output() updated = new EventEmitter();
  @ViewChild('cancelDebateModal', { static: false }) public cancelDebateModal: ModalComponent;
  public listId: string = 'marsTutorizationDebateOpinionsTable';

  public computedDebateData: any;
  public opinionsCache = new Cache();

  public toolbarConfig: any;
  public dataSource: any;
  protected questions: QuestionBase<any>[] = [];

  constructor(
    private debatesService: MarsDebatesService,
    private popUpService: PopUpService,
    private translateService: TranslateService,
    private opinionsListService: MarsDebateOpinionsListService
  ) {}

  ngOnInit(): void {
    this.opinionsCache.data = this.debate.debate;
    this.dataSource = this.opinionsListService.getDatasource(this.listId, this.opinionsCache);

    this.toolbarConfig = {
      list: {
        listId: this.listId,
        columnChooser: false,
        hideItemsSelector: true,
        download: false,
        filterRow: false,
        hidePrint: true,
        skeletor: true
      }
    };

    this.computedDebateData = this.debatesService.getComputedDebateData(this.debate);
  }

  onCertifyDebateQuestion() {
    this.popUpService
      .showConfirm({
        title: this.translateService.instant('debates.messages.certifyQuestion'),
        text: this.translateService.instant('agents.deleteMessage'),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'actions.yes',
        cancelButtonText: 'actions.no'
      })
      .then(() => {
        const newStatus = this.computedDebateData.validStatuses.CERTIFIED;
        return this.updateDebateQuestionStatus({ newStatus });
      });
  }

  onCancelDebateQuestion() {
    this.openCancelDebateModal();
  }

  updateDebateQuestionStatus(data) {
    const groupQuestionId = this.computedDebateData.groupQuestionId;
    this.closeCancelDebateModal();
    return this.debatesService
      .updateDebateQuestion(groupQuestionId, data)
      .then(() => {
        return this.debatesService.getDebate(this.debate.id).subscribe((debate) => {
          this.debate = debate;
          this.opinionsCache.data = this.debate.debate;
          this.dataSource.refreshData();
          this.updated.emit(this.debate);
          this.computedDebateData = this.debatesService.getComputedDebateData(this.debate);
        });
      })
      .catch((err) => {
        this.popUpService
          .showError({
            title: this.translateService.instant('debates.messages.error'),
            text: err.serverMessage
          })
          .then();
      });
  }

  public openCancelDebateModal(): void {
    this.questions = [this.setQuestions()];
    this.cancelDebateModal.open();
  }

  public closeCancelDebateModal(): void {
    this.cancelDebateModal.close();
  }

  public onSubmit(debateData: { reason: string }) {
    const newStatus = this.computedDebateData.validStatuses.CANCELLED;
    this.updateDebateQuestionStatus({ newStatus, explanation: debateData.reason }).then();
  }

  private setQuestions(): TextareaQuestion {
    return new TextareaQuestion({
      key: 'reason',
      label: 'debates.messages.reason',
      placeholder: 'debates.messages.cancelInputPlaceholder',
      validators: {
        required: true,
        maxLength: 2000
      },
      heightBox: 200,
      value: null
    });
  }
}
